import { Star, Clock, CreditCard, Flame } from "lucide-react";

const badges = [
  { icon: Star, label: "83% Loved by locals" },
  { icon: Clock, label: "Ready in ~12 min" },
  { icon: CreditCard, label: "Apple Pay & Contactless" },
  { icon: Flame, label: "Fresh from the tandoor" },
];

export default function TrustBadges({ variant = "light" }) {
  const isLight = variant === "light";
  return (
    <div
      data-testid="trust-badges"
      className="flex flex-wrap items-center gap-2 md:gap-3"
    >
      {badges.map(({ icon: Icon, label }, i) => (
        <span
          key={i}
          data-testid={`trust-badge-${i}`}
          className={`inline-flex items-center gap-2 text-xs md:text-sm font-medium px-3.5 py-2 rounded-full border ${
            isLight
              ? "bg-white/95 border-[#E7E5E4] text-[#1C1B2B]"
              : "bg-white/10 border-white/15 text-white backdrop-blur"
          }`}
        >
          <Icon
            className={`w-3.5 h-3.5 ${isLight ? "text-[#C9853E]" : "text-[#E5B07D]"}`}
          />
          {label}
        </span>
      ))}
    </div>
  );
}
